import { fromJS } from 'immutable';
import {
  SHOW_MODAL,
  HIDE_MODAL,
} from './constants';

const initialState = fromJS({});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return state.setIn(
        [action.name],
        true
      );
    case HIDE_MODAL:
      return state.setIn(
        [action.name],
        false
      );
    default:
      return state;
  }
};

export default reducer;
